/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Pause_While_Typing_HelpInputs */



/**
* | output |
* | --- |
* | "Automatically pause/resume playback when transcribing." |
*
* @param {Options_Editor_Pause_While_Typing_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_pause_while_typing_help = /** @type {((inputs?: Options_Editor_Pause_While_Typing_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Pause_While_Typing_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre automatiquement en pause/reprendre la lecture lors de la transcription.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Wiedergabepause/Wiedergabefortsetzung beim Transkribieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metti in pausa/riprendi automaticamente la riproduzione durante la trascrizione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая приостановка/возобновление воспроизведения при транскрибировании.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pausa/reanuda automáticamente la reproducción al transcribir.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转录时自动暂停/恢复播放。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("転記時に再生を自動的に一時停止/再開します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्शन करते समय प्लेबैक स्वचालित रूप से रुक जाएगा/फिर से शुरू हो जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pausar/retomar automaticamente a reprodução durante a transcrição.")
	return /** @type {LocalizedString} */ ("Automatically pause/resume playback when transcribing.")
});